const socketio = require('socket.io-client')
const eb = require('@/services/eventBus')
const customLogger = require('@/utils').customLogger

const socketService = {

  socket: undefined,
  startSocket: function(host, arg) {

    this.socket = socketio.connect(host + '/b2b_user', arg)

    this.socket.on("connect", () => {
      customLogger("************ Cleed.ai sockets: ************");
      customLogger("Successfull Hand Shake");
      customLogger("*******************");
    })
    .on("error", (err) => {
      customLogger("************ Cleed.ai sockets Error: ************");
      customLogger(err);
      customLogger("************ Error ************");
    });

    this.socket.on('search', (data) => eb.emit('ChatSeach', data))

    this.socket.on('message', (data) => {
        eb.emit('ChatReceiveMessage', data)
    })

    this.socket.on('admin_msg_add', (data) => {
        eb.emit('ChatReceiveMessage', data)
    })

    this.socket.on('delete_message_from_slack', (data) => {
      eb.emit('SlackMessageDeleted', data)
    })

    const store = require('@/store').default
    this.socket.on('Moptions', (msg) => {
        store.commit("Message_live_change", msg)
    })
    
    this.socket.on('TypingTracker',(data) => {
      store.commit("Message_TypingTracker", data)
    })

    this.socket.on('ChatConfigChange',(data) => {
      store.commit("UPDATE_CHAT_CONFIG", data)
      eb.emit("UpdateChatConfig")
    })

    //#region video chat
    this.socket.on('GettingCall', (data) => {
      store.dispatch("VIDEO_SOCKET_GettingCall", data)
      store.state.videoChat.socketAddr = this.socket
    })
    this.socket.on('ADMIN_end_calling', (data) => {
      store.dispatch("VIDEO_SOCKET_ADMIN_end_calling", data)
    })
    this.socket.on('ADMIN_send_message', (data) => {
      store.dispatch("VIDEO_SOCKET_ADMIN_send_message", data)
    })
    this.socket.on('videoChat_My_send_message', (data) => {
      store.dispatch("VIDEO_SOCKET_My_send_message", data)
    })
    this.socket.on('ADMIN_mediaDevices_Change', (data) => {
      store.commit("VIDEO_SOCKET_ADMIN_mediaDevices_Change", data)
    })
    this.socket.on('AdminStartSharingScreen', (data) => {
      store.commit('ENABLE_SCREEN_SHARE', data);
    })

    this.socket.on('QuestionsGenerated', (data) => {
      eb.emit('ChatReceiveMessage', data)
    })
    
    //#endregion

    //#region ai streaming
    this.socket.on('streaming_broadcast', (data) => {
      store.dispatch("UPDATE_STREAMING_MESSAGE", data)
    })
    //#endregion

    window.socketio = this.socket
  }
 
}

module.exports = socketService
